import type { BeneficialOwnerData, BeneficialOwnerResponse } from '@gcv/shared';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { BeneficialOwnerApi } from 'api';
import { DISPENSARY_BENEFICIAL_OWNERS_KEY } from 'hooks/keys';

export function useCrbUpdateBeneficialOwner(dispensaryId: string) {
  const beneficialOwnerApi = new BeneficialOwnerApi();
  const queryClient = useQueryClient();

  const { mutate: updateBeneficialOwner, isPending: isUpdatingBeneficialOwner } = useMutation({
    mutationKey: [DISPENSARY_BENEFICIAL_OWNERS_KEY, dispensaryId],
    mutationFn: ({
      beneficialOwnerId,
      beneficialOwner,
      questionnaireBankId
    }: {
      beneficialOwnerId: string;
      beneficialOwner: BeneficialOwnerData;
      questionnaireBankId?: string;
    }) =>
      beneficialOwnerApi.crbUpdateBeneficialOwner(
        dispensaryId,
        beneficialOwnerId,
        beneficialOwner,
        questionnaireBankId
      ),
    onSuccess: (updatedOwner) => {
      return queryClient.setQueryData(
        [DISPENSARY_BENEFICIAL_OWNERS_KEY, dispensaryId],
        (old: BeneficialOwnerResponse[] | undefined) =>
          old?.map((owner) => (owner.id === updatedOwner.id ? updatedOwner : owner))
      );
    },
    meta: {
      snackbarSuccessMessage: 'Beneficial owner updated successfully.',
      snackbarErrorMessage: 'There was an issue updating beneficial owner.'
    }
  });

  return { updateBeneficialOwner, isUpdatingBeneficialOwner };
}
